/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { getLedgersId } from "../../../shared/services/services";
import { LedgerRecord } from "../../../shared/services/interface";

const useSpecifiedLedger = (id: string, reload?: any) => {
  const [ledgers, setLedgers] = useState<LedgerRecord>();
  const [loading, setLoading] = useState(false);

  const fetchLedgers = () => {
    setLoading(true);
    if (!id) return;
    getLedgersId(id)
      .then((res) => {
        setLedgers(res.data.ledger);
      })
      .catch((error) => console.error(error))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchLedgers();
  }, [reload, id]);

  return { ledgers, loading, setLedgers };
};

export default useSpecifiedLedger;
